<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <section class="content">
        <b-card class="mb-3" :header="heading" no-body>
          <div class="card-body">
            <div class="form">
              <div class="form-row">
                <div class="col-md-6">
                  <b-form-group label="Name:">
                    <b-form-input v-model="itemForm.name" />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Clients:">
                    <b-form-select
                      multiple
                      v-model="itemForm.accessBrandsIds"
                      :searchable="true"
                      :options="brandsList"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Warehouses:">
                    <b-form-select
                      multiple
                      v-model="itemForm.accessWarehouseIds"
                      :searchable="true"
                      :options="warehousesList"
                    />
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </section>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <button
          class="btn btn-block btn-primary"
          type="submit"
          @click="SaveForm"
        >
          Save Changes
        </button>
        <router-link
          class="mt-2 btn btn-block btn-danger"
          :to="{ name: 'Integrations.ApiAccess.Index' }"
        >
          Cancel
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'APIAccess.Form',
  mixins: [crudMixinGen('apiAccess'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Api Access Form'
  }),

  computed: {
  },

  watch: {
  },

  mounted() {
    this.ResetForm();
    if (this.id) {
      this.LoadItem(this.id);
    } else {
      this.readyToLoad = true;
    }
  },

  methods: {

    SaveForm() {
      this.SaveItem()
      .then(resp => {
        if (resp.data.success) {
          this.$swal({ title: 'API Access Info Was Saved.', icon: 'info' });
          this.$router.push({
            name: 'Integrations.APIAccess.Index'
          });
        } else {
          this.$swal({ title: resp.errorMessage, icon: 'error' });
        }
      })
      .catch(err => {
        console.error('saved po err', err);
      });
    }
  }
};
</script>
